import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';

export const twilioApi = createApi({
  reducerPath: 'Twilio',
  tagTypes: ['Twilio'],
  baseQuery: baseQuerySample,

  endpoints: (builder) => ({
    getTwilioRecentLogs: builder.query({
      query: () => ({
        url: '/twilio/logs/recent',
      }),
    }),
    checkPhoneNumber: builder.query({
      query: (number: string) => ({
        url: `/twilio/lookup/line-type?phoneNumber=+1${number}`,
      }),
    }),
    sendSms: builder.mutation({
      query: ({ body = {}, params = {} }) => ({
        url: `/twilio/sms`,
        method: 'POST',
        body,
        params,
      }),
    }),
    getNotification: builder.query({
      query: (params?: Record<string, any>) => ({
        url: '/twilio/notification/get-notification',
        method: 'GET',
        params,
      }),
    }),
    deleteAllNotifications: builder.mutation<void, void>({
      query: () => ({
        url: '/twilio/notification/delete',
        method: 'POST',
      }),
      invalidatesTags: [{ type: 'Twilio', id: 'Notifications' }],
    }),
    getNotificationByID: builder.query({
      query: (id) => ({
        url: `/twilio/notification/seen/${id}`,
      }),
    }),
  }),
});
export const {
  useLazyGetNotificationByIDQuery,
  useGetNotificationQuery,
  useLazyGetNotificationQuery,
  useGetTwilioRecentLogsQuery,
  useLazyCheckPhoneNumberQuery,
  useSendSmsMutation,
  useDeleteAllNotificationsMutation,
} = twilioApi;
